import { randomIntBetween, AJAX_TYPE_LOAD_MORE } from '../utils/global'

export default {
    init: (app, Listing) => {
        const filters = document.getElementById('filters')
        const container = document.querySelector('.news-container')
        const skeleton = document.getElementById('news-skeleton').content.firstElementChild
        const listing = new Listing(filters, container)

        filters.addEventListener('loadstart', e => {
            const [type] = e.detail
            
            if(type === AJAX_TYPE_LOAD_MORE) {
                listing.loadMoreElement.dataset.loading = true
            } else {
                const page = listing.pages[listing.pages.length - 1]
                
                page.innerHTML = ''

                for(let i = 1; i <= 3; i++) {
                    const item = skeleton.cloneNode(true)

                    item.querySelectorAll('.news-skeleton-title').forEach(title => {
                        title.style.setProperty('--length', `${randomIntBetween(20, 60)}ch`)  
                    })

                    page.appendChild(item)
                }
            }
        })

        filters.addEventListener('loadend', e => {
            const [type] = e.detail

            if(type === AJAX_TYPE_LOAD_MORE) {
                listing.loadMoreElement.dataset.loading = false
            }
        })
    }
}